import React from "react";
import { ArrowRight } from "lucide-react";
import { track } from "../../../lib/analytics";

const PARTNERS = ["TourRadar", "Intrepid Travel", "BookRetreats", "GetYourGuide"];

// Honest affiliate prompt — no fake claims or invented offers.
export const AffiliateCTA = ({ browseTo = "/#escapes", label = "Browse retreats" }) => (
  <section data-testid="affiliate-cta" className="bg-brand-ink text-white">
    <div className="mx-auto flex max-w-[1200px] flex-col items-start justify-between gap-6 px-6 py-14 md:flex-row md:items-center md:px-10">
      <div className="max-w-2xl">
        <p className="overline text-white/60">Ready when you are</p>
        <h2 className="mt-2 font-display text-2xl leading-tight md:text-3xl">
          Compare and book with trusted partners
        </h2>
        <p className="mt-2 text-sm text-white/70">
          We link you directly to {PARTNERS.join(", ")} — at no extra cost to you. We may earn a small
          referral fee. See our <a href="/affiliate-disclosure" className="underline">Affiliate Disclosure</a>.
        </p>
      </div>
      <a
        href={browseTo}
        onClick={() => track("affiliate_cta_clicked", { browse_to: browseTo })}
        data-testid="affiliate-cta-button"
        className="inline-flex shrink-0 items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-medium text-brand-ink transition-colors hover:bg-brand-bg2"
      >
        {label} <ArrowRight size={15} />
      </a>
    </div>
  </section>
);

export default AffiliateCTA;
